import React from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'shared/components/table/DataTable';
import { searchUsers } from 'shared/api/admin';
import { dateString } from 'shared/utils';

const columns = [
  {
    name: 'Email',
    formatter: (row) => <Link to={`/user/view/${row.employeeId}`}>{row.email}</Link>,
    orderBy: 'email',
  },
  {
    name: 'Name',
    jsonKey: 'fullname',
    orderBy: 'fullname',
  },
  {
    name: 'Username',
    jsonKey: 'username',
    orderBy: 'username',
  },
  {
    name: 'Role',
    jsonKey: 'role',
    orderBy: 'role',
  },
  {
    name: 'Confirmed?',
    orderBy: 'status',
    formatter: (row) => (row.status === 'CONFIRMED' ? 'Yes' : 'No'),
  },
  {
    name: 'Active Sessions',
    jsonKey: 'activeSessions',
    orderBy: '8',
  },
  {
    name: 'Last Authenticated',
    formatter: (row) => dateString(row.lastAuthenticated),
    orderBy: '6',
  },
  {
    name: 'Password Updated',
    formatter: (row) => dateString(row.passwordCreated),
    orderBy: '7',
  },
];

export default function UserSearch() {
  return (
    <DataTable
      tableName="Users"
      searchRequest={searchUsers}
      rowId="employeeId"
      columns={columns}
      className="table-height-large"
    />
  );
}
